interface Props {
  logoPath: string | null;
  logoInvert?: boolean;
  name: string;
}

/** Channel logo or, when none is uploaded, the channel name as a badge. */
export function ChannelLogo({ logoPath, logoInvert = false, name }: Props) {
  if (logoPath) {
    return (
      <img
        src={logoPath}
        alt={name}
        className="h-14 w-auto object-contain md:h-16"
        style={logoInvert ? { filter: 'invert(1) brightness(2)' } : undefined}
      />
    );
  }
  return (
    <div className="rounded-md bg-neutral-800 px-4 py-2 text-xl font-semibold uppercase tracking-wider">
      {name}
    </div>
  );
}
